import { ButtonHTMLAttributes, default as React, ReactNode } from "react";
import { ButtonVariants, buttonStyles } from "./buttonVariants";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonVariants & {
    children: ReactNode;
  };

export default function Button({
  color,
  size,
  raised,
  outlined,
  className,
  disabled,
  children,
  ...restProps
}: ButtonProps) {
  return (
    <button
      type="button"
      className={buttonStyles({ color, size, raised, outlined, disabled, className })}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
}
